import { useActivityTemplateType } from "PFApp/activities/hooks";
import { TemplateKey } from "PFApp/constants/templates";
import { useActivityLink } from "PFApp/hooks";
import { useTranslation } from "react-i18next";

import { useBookingActivityContext } from "../../../parts/providers/booking_activity_context_provider";
import { EntityIcon } from "../../entity_icon";
import { DetailsHeader } from "./details_header";

export const RoleDetailHeader = () => {
  const { t } = useTranslation();
  const { activity, parentActivity } = useBookingActivityContext();
  const linkUrl = useActivityLink({ activity, parentActivity });

  const { isAudit, isRole } = useActivityTemplateType(activity);
  const isAuditRole = isAudit && isRole;

  return activity ? (
    <DetailsHeader
      title={activity?.name}
      subtitle={isAuditRole ? t("auditRole") : t("role")}
      linkUrl={linkUrl ?? undefined}
    >
      <EntityIcon templateId={activity?.template_id} type={TemplateKey.Role} />
    </DetailsHeader>
  ) : null;
};
